import { render, staticRenderFns } from "./botAddDialog.vue?vue&type=template&id=33690d24&scoped=true"
import script from "./botAddDialog.vue?vue&type=script&lang=js"
export * from "./botAddDialog.vue?vue&type=script&lang=js"
import style0 from "./botAddDialog.vue?vue&type=style&index=0&id=33690d24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33690d24",
  null
  
)

export default component.exports